
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SendRegulDocsMailsParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SendRegulDocsMailsParameters.ts

export class SendRegulDocsMailsParameters {

  // int SupplierId
  public SupplierId: number=0;

  // string MailModelCod
  public MailModelCod?: string=null;

  // int? RefDocId
  public RefDocId?: number=null;

  // bool TopEnvoiMail
  public TopEnvoiMail: boolean=false;
}